import React, { useEffect, useState } from "react";
import { Search, RefreshCw, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

export const MinyoCard = () => {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/minyo").then((r) => setD(r.data)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 120000); return () => clearInterval(t); }, []);
  const scan = async () => {
    setBusy(true);
    try { const r = (await api.post("/minyo/scan", null, { timeout: 120000 })).data; setD((x) => ({ ...x, live: r.picks })); toast.success(`Minyo: ${r.picks.length} small-caps cleared`); }
    catch (e) { toast.error("Minyo scan failed"); }
    setBusy(false);
  };
  if (!d) return null;
  const picks = d.live || d.picks || [];
  const g = (d.grades || [])[0];
  const tp = (d.grades || []).reduce((a, x) => a + x.picks, 0), th = (d.grades || []).reduce((a, x) => a + x.hits, 0);
  return (
    <div className="bg-[#060b18] border border-[#F472B644] rounded-2xl p-4" data-testid="minyo-card">
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-[#F472B61a] border border-[#F472B666] flex items-center justify-center"><Search className="w-5 h-5 text-[#F472B6]" /></div>
          <div>
            <p className="text-pink-50 font-bold">Mr Minyo <span className="text-xs text-cyan-200/50 font-normal">· Small-Cap Scout · runs with Mr Scott</span></p>
            <p className="text-xs text-cyan-200/60" data-testid="minyo-hit-rate">Hit rate today {g?.day === d.picks?.[0]?.day && g ? `${g.hit_rate}% (${g.hits}/${g.picks})` : "—"} · 30d {tp ? `${Math.round((100 * th) / tp)}% (${th}/${tp})` : "—"}</p>
          </div>
        </div>
        <button onClick={scan} disabled={busy} data-testid="minyo-scan-btn" className="px-3 py-1.5 rounded-lg border border-pink-300/30 text-pink-100 text-xs flex items-center gap-1">
          {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <RefreshCw className="w-3.5 h-3.5" />} Scan now
        </button>
      </div>
      <p className="text-[10px] nx-mono text-cyan-200/40 mt-2">{d.rules?.universe} · {d.rules?.screen} · size ≤{d.rules?.size_cap_pct}% · stop −{d.rules?.hard_stop_pct}%</p>
      <div className="mt-3 space-y-1.5">
        {picks.map((p) => (
          <div key={p.ticker} className="grid grid-cols-[4rem_4.5rem_1fr] sm:grid-cols-[4.5rem_5rem_9rem_1fr_3rem] gap-2 items-center rounded-lg px-2 py-1.5 border border-white/5" data-testid={`minyo-pick-${p.ticker}`}>
            <b className="nx-mono text-pink-50">{p.ticker}</b>
            <span className="nx-mono text-xs text-emerald-300">+{(p.change_pct || 0).toFixed(1)}% {(p.rel_vol || 0).toFixed(1)}x</span>
            <span className="hidden sm:block nx-mono text-[11px] text-cyan-100/70">E {p.entry} · T {p.target} · S {p.stop}</span>
            <span className="text-[11px] text-cyan-200/60 truncate">{p.catalyst}</span>
            <span className={`hidden sm:block nx-mono text-[10px] text-right ${p.hit ? "text-emerald-300" : "text-cyan-200/40"}`}>{p.hit ? "HIT" : `liq ${p.opt_liq}/5`}</span>
          </div>
        ))}
        {!picks.length && <p className="text-sm text-cyan-200/40">No small-cap has cleared the screen yet today.</p>}
      </div>
    </div>
  );
};
